@if(this.dubbeleBanenOfUitkeringen()) {
  <form [formGroup]="dubbelePositie">
    <div class="row">
      <div class="col-auto pt-1">
        <p>Zijn er 2 (of meer) banen of uitkeringen tegelijk in {{ aangifte.aangifteJaar }}?</p>
      </div>
      <div class="col-auto">
        <snelstart-ui-select-form-control (change)="saveForm()"
                                          [options]="optionsJaNee"
                                          class="custom-input-150"
                                          formControlName="dubbelePositie"
                                          id="dubbelePositie"
        >
        </snelstart-ui-select-form-control>
      </div>
    </div>
  </form>
  <snelstart-ui-alert type="info">
    Bij de berekening van de verschuldigde inkomstenbelasting wordt rekening gehouden met de reeds gedurende het
    jaar ingehouden loonheffing. Het programma berekent zelf de (verwachte) ingehouden loonhjeffing. Daarbij is van
    belang of er sprake is van tegelijk 2 banen of uitkeringen.
  </snelstart-ui-alert>
}

